"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthContext = void 0;
exports.AuthProvider = AuthProvider;
exports.useAuth = useAuth;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _functions = require("../../../@functions");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["children"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * @typedef CertificateModel
 * @type {import("web-pki-fixed").CertificateModel}
 */

/**
 * @typedef AuthPageProps
 * @type {{
 *     app: "collectame" | "dokplus" | "indexia" | "workflux" | "appcenter-customer" | "workflux-portal";
 *     hideSpinner: () => void;
 *     showSpinner: () => void;
 *     showMessage: (
 *        title: string | JSX.Element,
 *        description: string | JSX.Element
 *     ) => void;
 *     hideMessage: () => void;
 *     loginWithSSO?: (token: string) => Promise<void>;
 *     goToPage?: (path: string) => void;
 *     urlProps?: {
 *        params: {
 *          recoveryToken?: string
 *        }
 *     };
 *     auth?: {
 *        isAuthenticated: boolean
 *     };
 * 	   domain?: string;
 * 	   external: boolean;
 *     children?: React.ReactNode;
 * 	   loginWithGoogle?: (token: string, company: string) => Promise<void>
 * 	   loginWithLinkedIn?: (token: string, company: string) => Promise<void>
 * 	   loginWithFacebook?: (token: string, company: string) => Promise<void>
 *     loginWithEmail?: (
 *        email: string,
 *        password: string,
 *        company?: string
 *     ) => ;
 *     loginWithCertificate: (
 *         cpf: string,
 *         certificate: CertificateModel;
 *     ) => Promise<void>;
 *     logout?: () => Promise<void>
 * }}
 */
/**
 * @type {React.Context<AuthPageProps | undefined>}
 */
var AuthContext = (0, _react.createContext)(undefined);

/**
 * @param {AuthPageProps} props
 * @returns {JSX.Element}
 */
exports.AuthContext = AuthContext;
function AuthProvider(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var domain = (0, _functions.getDomain)();
  var external = rest.app === 'workflux-portal';
  return /*#__PURE__*/_react["default"].createElement(AuthContext.Provider, {
    value: _objectSpread(_objectSpread({}, rest), {}, {
      external: external,
      domain: domain
    })
  }, children);
}
AuthProvider.propTypes = {
  app: _propTypes["default"].string.isRequired,
  urlProps: _propTypes["default"].shape({
    params: _propTypes["default"].shape({
      recoveryToken: _propTypes["default"].string
    }).isRequired
  }).isRequired,
  hideSpinner: _propTypes["default"].func.isRequired,
  showSpinner: _propTypes["default"].func.isRequired,
  showMessage: _propTypes["default"].func.isRequired,
  hideMessage: _propTypes["default"].func.isRequired,
  goToPage: _propTypes["default"].func.isRequired,
  auth: _propTypes["default"].shape({
    isAuthenticated: _propTypes["default"].bool.isRequired
  }).isRequired,
  loginWithSSO: _propTypes["default"].func.isRequired,
  loginWithCertificate: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].node.isRequired,
  loginWithEmail: _propTypes["default"].func.isRequired,
  loginWithGoogle: _propTypes["default"].func,
  loginWithLinkedIn: _propTypes["default"].func,
  loginWithFacebook: _propTypes["default"].func,
  logout: _propTypes["default"].func.isRequired
};
function useAuth() {
  var context = (0, _react.useContext)(AuthContext);
  if (!context) throw new Error('useAuth must be used withing a AuthProvider');
  return context;
}